type CurvedHalfCircleProps = {
  className?: string;
  fill?: string;
  transform?: string;
};

export function CurvedHalfCircle({
  className,
  fill = 'white',
  transform,
}: CurvedHalfCircleProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 1874 608"
      fill="none"
    >
      <path
        d="M1874 0C1789.1 13.4334 1718.11 75.9895 1677.86 154.592C1540 423.781 1260 608 936.999 608C614.003 608 334.002 423.781 196.14 154.592C155.885 75.9895 84.8949 13.4334 0 0H1874Z"
        fill={fill}
        style={{ transformOrigin: 'center' }}
        transform={transform}
      />
    </svg>
  );
}
